import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { PaperPlaneIcon } from '../../theme/Icons';
import { BRAND } from './agencyChartTheme';

const useStyles = createUseStyles({
    box: {
        '@media print': {
            display: 'none'
        }
    },

    opener: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        minHeight: 48,
        padding: '6px 14px 6px 8px',
        borderRadius: 16,
        border: `1px solid ${BRAND.tealEdge}`,
        background: 'var(--ion-background-color)',
        font: 'inherit',
        fontSize: 15,
        color: 'var(--ion-color-step-700)',
        textAlign: 'left' as const,
        cursor: 'pointer',

        '&:focus-visible': {
            outline: 'none',
            borderColor: 'var(--ion-color-primary)',
            boxShadow: '0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.12)'
        }
    },

    avatar: {
        width: 34,
        height: 34,
        flexShrink: 0,
        borderRadius: '50%',
        objectFit: 'cover' as const
    },

    text: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap' as const,
        textOverflow: 'ellipsis'
    }
});

/** The Insights message box on a narrow window: one line that opens agency Bea full screen, asking nothing. */
export const InsightsBeaOpener: FC<{ prompt: string; avatar: string; onOpen: () => void }> = ({ prompt, avatar, onOpen }) => {
    const classes = useStyles();
    return (
        <div className={classes.box} data-id="insights-ask-bea-box">
            <button type="button" className={classes.opener} data-id="insights-ask-bea" onClick={onOpen}>
                <img src={avatar} alt="" className={classes.avatar} />
                <span className={classes.text}>{prompt}</span>
                <PaperPlaneIcon color="primary" />
            </button>
        </div>
    );
};
